import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { addCommasToNum } from '@tekion/tekion-base/formatters/number';

// Styles
import s from './filterResults.module.scss';
var renderDefaultResultsLabel = function renderDefaultResultsLabel(resultsCount) {
  var formattedCount = addCommasToNum(resultsCount) || 0;
  return __('{{formattedCount}} Result(s)', {
    formattedCount: formattedCount
  });
};
var FilterResults = function FilterResults(props) {
  var resultsCount = props.resultsCount,
    className = props.className,
    showOnlyResults = props.showOnlyResults,
    renderResultsLabel = props.renderResultsLabel;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(s.container, className, _defineProperty({}, s.withFilters, !showOnlyResults))
  }, renderResultsLabel(resultsCount));
};
FilterResults.propTypes = {
  resultsCount: PropTypes.number,
  className: PropTypes.string,
  showOnlyResults: PropTypes.bool,
  renderResultsLabel: PropTypes.func
};
FilterResults.defaultProps = {
  resultsCount: 0,
  className: '',
  showOnlyResults: false,
  renderResultsLabel: renderDefaultResultsLabel
};
export default FilterResults;